/** check if value not empty */
const notUndefOrNull = val => val !== undefined && val !== null;
/** getClientRect */
const getClientRect = elem => {
  if (!elem || !elem.getBoundingClientRect || typeof elem.getBoundingClientRect !== 'function') {
    return {
      width: 0,
      x: 0
    };
  }
  const {
    left = 0,
    width = 0
  } = elem.getBoundingClientRect();
  return {
    width,
    x: +left
  };
};
const formatTranslate = val => +val.toFixed(0);

/** check if translate is valid */
const translateIsValid = val => typeof val === 'number' && !isNaN(+val);
/** pass translate value and default, valid - return formatted value, not valid - return default */
const validateTranslate = (value, defaultValue) => translateIsValid(value) ? +value : defaultValue;

/** test passive event support, for performance */
// maybe use separate package detect-passive-events
const testPassiveEventSupport = () => {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        // This function will be called when the browser
        // attempts to access the passive property.
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener('testPassiveEventSupport', options, options);
    window.removeEventListener('testPassiveEventSupport', options, options);
  } catch (err) {
    passiveSupported = false;
  }
  return passiveSupported;
};

export { formatTranslate, getClientRect, notUndefOrNull, testPassiveEventSupport, translateIsValid, validateTranslate };
